import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
  selector: 'quantity-change',
  templateUrl: './quantity-change.component.html',
  styleUrl: './quantity-change.component.scss',
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class QuantityChangeComponent extends BaseWidget implements OnInit {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;

  quantity: number;
  action: any;
  ngOnInit(): void {
    this.quantity = this.slot?.widget?.data?.value?.value;
    this.action = this.slot?.widget?.data?.action;
  }

  quantityChangeManually(event: Event, action: any) {
    const inputElement = event.target as HTMLInputElement;
    const quantity = inputElement.value;
    const numericQuantity =
      parseInt(quantity) > 0
        ? parseInt(quantity)
        : this.slot?.widget?.data?.value?.moq; // Ensure quantity is a number, default to moq if NaN
    let modifiedAction = action;
    modifiedAction.params.quantity = numericQuantity;
    this.actionEvent({
      actionData: { ...modifiedAction },
    });
  }

  quantityChange(action: any) {
    this.actionEvent({
      actionData: { ...action },
    });
  }
}
